import { Paragraph } from '@unistocks/components/text/text';
import { styled } from 'tamagui';

export const SavingsGoalParagraph = styled(Paragraph, {
  userSelect: 'none'
});
